<template>
  <div class="users-card">
    <div>
      <div class="info">
        <div class="info__header">
          <h1>Aderência</h1>
        </div>
        <div class="info__item not-registered">
          <p>Pré-Cadastrados</p>
          <h3>{{ users.preregistered }}</h3>
        </div>
        <div class="info__item registered">
          <p>Usuários Ativos</p>
          <h2>{{ users.active }}</h2>
        </div>
        <div class="info__item registered">
          <p>Ex-Usuários</p>
          <h5>{{ users.ex_client }}</h5>
        </div>
        <div class="info__item not-registered">
          <p>Usuários Inativos</p>
          <h4>{{ users.inactive }}</h4>
        </div>
      </div>
      <div class="chart">
        <users-chart :data="users"></users-chart>
      </div>
    </div>
  </div>
</template>

<script>
import UsersChart from '@/components/HomePage/UsersChart.vue';
import { mapState } from 'vuex';

export default {
  name: 'users-card',
  components: {
    UsersChart,
  },
  computed: mapState({
    users: (state) => state.dashboard.users,
  }),
};
</script>

<style lang="scss" scoped>
.users-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 12px 24px;
  padding-right: 12px;
  box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);

  > div {
    display: flex;

    .info {
      flex: 1;
      margin-right: 32px;
    }

    .chart {
      width: 160px;
      min-height: 160px;
    }
  }

  .info {
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      h1 {
        font-size: 1.2rem;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      
      h2 {
        font-size: 1.2rem;
        
        color: #48d376;
      }
      
      h3 {
        font-size: 1.2rem;
        color: #130d85;
      }
      h4 {
        font-size: 1.2rem;
        color:  #8a3cf7;
      }
      h5 {
        font-size: 1.2rem;
        color: #d04040;
      }

      &.registered > p:last-child::after {
        background: var(--color-success);
      }

      &.not-registered > p:last-child::after {
        background: var(--color-danger);
      }

      &:not(:last-child) {
        padding-bottom: 3px;
      }

      &:last-child {
        padding-top: 3px;
      }

      p:last-child {
        color: var(--text-color-light);
        position: relative;

        &::after {
          content: '';
          border-radius: 50%;
          width: 6px;
          height: 6px;
          position: absolute;
          top: 0;
          right: -5px;
        }
      }
    }
  }
}
</style>
